import { Platform } from 'react-native'
import _request from '../lib/request'
import Battery from './battery'
import Constants from 'expo-constants'

class API {
  constructor () {
    this.hostname = ''
    this.token = null
    this.gameId = null
  }

  request (opts) {
    if (this.token) {
      opts.headers = { Authorization: `Bearer ${this.token}` }
    } else if (Platform.OS !== 'web') {
      opts.headers = { 'x-api-key': 'tablet' }
    }
    return _request(opts)
  }

  setHost (newHostname) {
    this.hostname = `${newHostname}/api`
  }

  setToken (token) {
    this.token = token
  }

  setGameId (gameId) {
    this.gameId = gameId
  }

  getGames (hostname) {
    return this.request({ url: `${hostname}/api/games` })
  }

  getContent () {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/content` })
  }

  getHelpUrl () {
    return `${this.hostname}/games/${this.gameId}/pdfs/help.pdf`
  }

  getNews (round) {
    return `${this.hostname}/games/${this.gameId}/pdfs/rounds/${round}/news.png`
  }

  getDealsPng (round) {
    return `${this.hostname}/games/${this.gameId}/pdfs/rounds/${round}/deals.png`
  }

  fetchFileUrl (path) {
    return `${this.hostname}${path.replace('/api', '')}`
  }

  async getSummary (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/summary`, funcName: 'Get Summary' })
  }

  async registerDevice (deviceId, team, isMaster, sideBarFontSize) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/setup/device`,
      body: {
        deviceId,
        teamId: team,
        isMaster,
        sideBarFontSize,
        batteryStatus: Battery.get()
      },
      funcName: 'Register Device'
    })
  }

  async getSetup () {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/setup`, funcName: 'Get Setup' })
  }

  async getDevice (deviceId) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/setup/device/${deviceId}`, funcName: 'Get Device' })
  }

  async getDeviceStatus (deviceId) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/setup/device/${deviceId}/status?batteryStatus=${Battery.get()}`, funcName: 'Get Device Status' })
  }

  async registerTeam (teamId, name, strategy) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/setup/team`,
      body: {
        teamId,
        name,
        strategy
      },
      funcName: 'Register Team'
    })
  }

  async submitRound (currentRound, teamId) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/rounds/${currentRound}/teams/${teamId}/submit`,
      funcName: 'Submit'
    })
  }

  async getBusinesses (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/businesses`, funcName: 'Get Businesses' })
  }

  async getFinancials (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/financials`, funcName: 'Get Financials' })
  }

  async updateDecisions (team, round, decisions, deviceId) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/businesses`,
      body: { decisions, deviceId },
      funcName: 'Update Business Decisions'
    })
  }

  async getProjects (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/projects`, funcName: 'Get Projects' })
  }

  async updateProjectDecision (team, round, projectId, businessId) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/projects`,
      body: { projectId, businessId },
      funcName: 'Update Project Decisions'
    })
  }

  async deleteProjectDecision (team, round) {
    return this.request({
      method: 'DELETE',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/projects`,
      funcName: 'Unselect project'
    })
  }

  async getTreasury (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/treasury`, funcName: 'Get Treasury' })
  }

  async updateTreasuryDecisions (team, round, decisions, deviceId) {
    try {
      const response = await this.request({
        method: 'PUT',
        url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/treasury`,
        body: { decisions, deviceId },
        funcName: 'Update Treasury Decisions'
      })
      return response
    } catch (err) {
      console.log('ERRROROROROR', err)
      throw err
    }
  }

  async getDeal (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/deals`, funcName: 'Get Deals' })
  }

  async bidOnDeal (team, round, bid) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/deals`,
      body: { bid },
      funcName: 'Bid on deal'
    })
  }

  async getExcoDecision (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/exco`, funcName: 'Get Exco Decision' })
  }

  async submitExcoDecision (team, round, decision) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/exco`,
      body: { decision },
      funcName: 'Submit exco decision'
    })
  }

  async getPeerInsights (team, round) {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/peer-insights`, funcName: 'Get Peer Insights' })
  }

  async getSurvey () {
    return this.request({ url: `${this.hostname}/games/${this.gameId}/survey` })
  }

  async submitSurvey (team, data) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/teams/${team}/survey`,
      body: data
    })
  }

  async getOpex (team, round) {
    // return this.request({ url: `http://localhost:3000/api/teams/1/rounds/1/opex`, funcName: 'Get Opex' })
    return this.request({ url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/opex`, funcName: 'Get Opex' })
  }

  async updateOpexDecisions (team, round, decisions, deviceId) {
    try {
      const response = await this.request({
        method: 'PUT',
        // url: `${this.hostname}/games/${this.gameId}/teams/1/rounds/1/opex`,
        url: `${this.hostname}/games/${this.gameId}/teams/${team}/rounds/${round}/opex`,
        body: { decisions, deviceId },
        funcName: 'Update Opex Decisions'
      })
      return response
    } catch (err) {
      console.log('ERRROROROROR', err)
      throw err
    }
  }

  async createCEOTransferRequest (deviceId, requestedDeviceId) {
    return this.request({
      method: 'POST',
      url: `${this.hostname}/games/${this.gameId}/device/${deviceId}/ceotransfer`,
      body: { to: requestedDeviceId }
    })
  }

  async acceptDeclineCEOTransferRequest (deviceId, requestId, action) {
    return this.request({
      method: 'PUT',
      url: `${this.hostname}/games/${this.gameId}/device/${deviceId}/ceotransfer/${requestId}`,
      body: { action }
    })
  }

  async getCEOTransferRequest (deviceId, requestId) {
    return this.request({
      method: 'GET',
      url: `${this.hostname}/games/${this.gameId}/device/${deviceId}/ceotransfer/${requestId}`
    })
  }

  async cancelCEOTransferRequest (deviceId, requestId) {
    return this.request({
      method: 'DELETE',
      url: `${this.hostname}/games/${this.gameId}/device/${deviceId}/ceotransfer/${requestId}`
    })
  }

  async getStatus () {
    const env = Constants.manifest.extra.environment
    let host = 'http://localhost:3000'
    if (env === 'test') {
      host = 'https://test-api.banksim.co'
    }
    if (env === 'production') {
      host = 'https://api.banksim.co'
    }
    return this.request({
      method: 'GET',
      url: `${host}/api/status`
    })
  }
}

export const getHost = () => this.hostname

export default new API()
